import { Button } from "@/components/ui/button";
import { useTheme } from "@/shared/providers/theme-provider";
import { Monitor, Moon, Sun } from "lucide-react";

/** Theme toggle button that cycles between light, dark, and system modes. */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const cycleTheme = () => {
    if (theme === "light") {
      setTheme("dark");
    } else if (theme === "dark") {
      setTheme("system");
    } else {
      setTheme("light");
    }
  };

  const getIcon = () => {
    switch (theme) {
      case "light":
        return <Sun className="h-4 w-4" />;
      case "dark":
        return <Moon className="h-4 w-4" />;
      default:
        return <Monitor className="h-4 w-4" />;
    }
  };

  const getLabel = () => {
    switch (theme) {
      case "light":
        return "Light";
      case "dark":
        return "Dark";
      default:
        return "System";
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={cycleTheme}
      aria-label={`Switch theme (current: ${getLabel()})`}
      data-testid="theme-toggle-button"
      className="gap-2"
    >
      {getIcon()}
      <span className="sr-only">{getLabel()} mode</span>
    </Button>
  );
}
